import axios from "axios";
import { env } from "../../../constants/env";
import ReusableTable from "../../ReusableTable/ReusableTable";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";
import { toast } from "react-toastify";
import { fetchCertificationSummary } from "../../../utils/offlineFetchCertifications";

const EquipmentManagement = () => {
  const navigate = useNavigate();
  const [tableData, setTableData] = useState([]);
  const { user } = useAuth();
  const userRole = user?.role;

  const { labId } = useParams(); // Replace with actual lab ID (from context, props, or auth)
  const name = "SLIPTA";
  const section = "Equipment Management";

  console.log("LAB ID", labId);

  useEffect(() => {
        const loadData = async () => {
          const data = await fetchCertificationSummary({
            labId,
            name: "SLIPTA",
            section, // or "Documents & Records"
          });
          setTableData(data);
        };
      
        if (labId) loadData();
      }, [labId, , name, section]);

  const sectionColumns = [
    { label: "Title", field: "title" },
    { label: "Total Score", field: "totalScore" },
    { label: "Created", field: "created" },
    { label: "Updated", field: "updated" },
    { label: "Status", field: "status" },
  ];
  return (
    <div>
      <ReusableTable
        title="Equipment management"
        columns={sectionColumns}
        showTopAdd={userRole === "ASSESSOR" ? tableData.length > 0 : false}
        data={tableData}
        onAdd={
          userRole === "ASSESSOR"
            ? () => navigate("add-equipment-management")
            : false
        }
        showDetails={false}
        onEdit={
          (row) => {
            if (row.status === "Attached") {
              toast.error("Can not edit as document is already attached");
            } else {
              navigate(`add-equipment-management/${row.id}`);
            }
          } // edit mode
        }
      />
    </div>
  );
};

export default EquipmentManagement;
